import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';

import { CharonHttpService } from './charon.http.service';

/**
 * Módulo de Comunicação com o Caronte
 */
@NgModule({
  providers: [
    CharonHttpService,
  ],
  imports: [
    HttpClientModule,
    CommonModule,
  ],
})
export class CharonHttpModule { }
